import React from 'react';
import { TextFieldProps } from '@mui/material';
import { Role } from '../../lib/types';
import { roleApi } from '../../lib/api';

import AutoCompleteSelect from './AutoCompleteSelect';

type Props = {
  onChange: (
    roleId: number | number[] | undefined,
    role: Role | undefined,
  ) => void;
} & Omit<TextFieldProps, 'onChange'>;
const RoleSelect = (props: Props) => {
  return (
    <>
      <AutoCompleteSelect
        id="roleId"
        name="roleId"
        label="Выберите роль"
        size="small"
        fullWidth
        fetch={roleApi.fetch}
        fetchSingle={roleApi.get}
        {...props}
      />
    </>
  );
};
export default RoleSelect;
